import {chatSvg as Icon__small__chatSvg} from '../Icon__small/Icon__small--chat.js'

export var chat = {
  name: 'chat',
  category: 'icon',
  colorable: true,
  svg: Icon__small__chatSvg,
};
